<div [formGroup]="optionsFg" class="main-container">
	<div></div>
	<mat-form-field style="margin-right: 20px; width: 320px">
		<mat-label>IRWIN ID</mat-label>
		<input matInput [formControl]="filterFg.get('irwinId')" />
		<mat-error *ngIf="filterFg.controls.irwinId?.hasError('invalidIrwinId')">
			Irwin id must be in the UUID format (EAA18302-B6C2-49C0-9332-B04A58C3CEC5)
		</mat-error>
	</mat-form-field>
	<div class="label">-OR-</div>
	<div class="details-container" [formGroup]="filterFg" style="display: flex; flex-wrap: wrap;">		
		<mat-form-field class="incidentDetails">
			<mat-label>Incident Name</mat-label>
			<input matInput formControlName="incidentName" />
		</mat-form-field>
		<mat-form-field class="incidentDetails">
			<mat-label>Unique Fire Identifier</mat-label>
			<input matInput formControlName="uniqueFireIdentifier" />
		</mat-form-field>
		<div class="incident-size" style="display: flex; flex-direction: row; align-items: center;">
			<mat-form-field class="incidentDetails range-dropdown" [formGroup]="optionsFg">
				<mat-label>Incident Size</mat-label>
				<mat-select formControlName="incidentSizeType" canSelectNullableOptions>
					<mat-option *ngFor="let numberRange of sizeAndCostDropdownOptions" [value]="numberRange.value">{{
						numberRange.label }}</mat-option>
					<mat-option [value]="null">No Selection</mat-option>
				</mat-select>
			</mat-form-field>
			<div style="display: flex; flex-direction: column" [formGroup]="filterFg">
				<div [hidden]="this.hideField.incidentSizeMin">
					<mat-form-field>
						<mat-label>Acres</mat-label>
						<input matInput type="number" formControlName="incidentSizeMin" />
					</mat-form-field>
				</div>
				<div [hidden]="this.hideField.incidentSizeAnd" class="and">and</div>
				<div [hidden]="this.hideField.incidentSizeMax">
					<mat-form-field>
						<mat-label>Acres</mat-label>
						<input matInput type="number" formControlName="incidentSizeMax" />
					</mat-form-field>
				</div>
			</div>		
		</div>
		<div class="est-final-cost" style="display: flex; flex-direction: row; align-items: center;">
			<div>
				<mat-form-field class="incidentDetails range-dropdown" [formGroup]="optionsFg">
					<mat-label>Estimated Final Cost (Last Published)</mat-label>
					<mat-select formControlName="estimatedFinalCostType" canSelectNullableOptions>
						<mat-option *ngFor="let numberRange of sizeAndCostDropdownOptions" [value]="numberRange.value">{{
							numberRange.label }}</mat-option>
						<mat-option [value]="null">No Selection</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<div [formGroup]="filterFg">
					<div [hidden]="this.hideField.estimatedFinalCostMin">
						<mat-form-field class="incidentDetails">
							<mat-label>Dollars</mat-label>
							<input matInput wfdssCurrencyFormat formControlName="estimatedFinalCostMin" />
						</mat-form-field>
					</div>
					<div [hidden]="this.hideField.estimatedFinalCostMax">
						<div [hidden]="this.hideField.estimatedFinalCostAnd" class="and">and</div>
						<mat-form-field class="incidentDetails">
							<mat-label>Dollars</mat-label>
							<input matInput formControlName="estimatedFinalCostMax" wfdssCurrencyFormat />
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div>
		<b class="label"> Filters </b>
	</div>
	<br>	
	<div style="display: flex; flex-direction: column; gap: 1rem;">
		<div style="display: flex; flex-direction: row; gap: 2.5rem;">
			<!-- Discovery Date -->
			<fieldset>
				<div style="display: flex; flex-direction: row; margin-right: 0.5rem">
					<div [formGroup]="radiosFg">
						<mat-radio-group
							color="primary"
							style="display: flex; flex-direction: column;"
							class="flex-radio-group"
							formControlName="discoveryDateRadio"
							[attr.aria-label]="'discovery date filter selection'">
							<mat-radio-button [value]="'Any'"> Any Discovery Date </mat-radio-button>							
							<div style="display: flex; flex-direction: row;">
								<mat-radio-button class="radio-option" [value]="'Discovered'" style="margin-right: 1rem;"> Discovered </mat-radio-button>
								<ng-container [ngTemplateOutlet]="discoveredDateFilters"></ng-container>
							</div>								 
						</mat-radio-group>
					</div>

					<ng-template #discoveredDateFilters>
						<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
							<mat-form-field class="dropdown" [formGroup]="optionsFg">
								<mat-select formControlName="discoveryDateDropdown">
									<mat-option *ngFor="let dateRangeValue of dateDropdownOptions" [value]="dateRangeValue">{{
										dateRangeValue }}</mat-option>
								</mat-select>
							</mat-form-field>
							<div style="margin-left: 5px">
								<div [hidden]="this.hideField.discoveredBetweenMin">
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerDiscLower" formControlName="discoveredBetweenMin" />
										<mat-datepicker-toggle matSuffix [for]="datePickerDiscLower"></mat-datepicker-toggle>
										<mat-datepicker #datePickerDiscLower></mat-datepicker>
									</mat-form-field>
								</div>
								<div [hidden]="this.hideField.discoveredBetweenMax">
									<div class="and" [hidden]="this.hideField.discoveredBetweenMin">and</div>
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerDiscUpper" formControlName="discoveredBetweenMax" />
										<mat-datepicker-toggle matSuffix [for]="datePickerDiscUpper"></mat-datepicker-toggle>
										<mat-datepicker #datePickerDiscUpper></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
							<div [hidden]="this.hideField.discoveryDateOn">
								<mat-form-field class="date-field">
									<input matInput [matDatepicker]="datePickerDiscOn" formControlName="discoveryDateOn" />
									<mat-datepicker-toggle matSuffix [for]="datePickerDiscOn"></mat-datepicker-toggle>
									<mat-datepicker #datePickerDiscOn></mat-datepicker>
								</mat-form-field>
							</div>
						</div>					
					</ng-template>
				</div>
			</fieldset>
			<!-- Initiated Date -->
			<fieldset>
				<div style="display: flex; flex-direction: row; margin-right: 0.5rem">
					<div [formGroup]="radiosFg">
						<mat-radio-group
							color="primary"
							style="display: flex; flex-direction: column;"
							class="flex-radio-group"
							formControlName="initiatedDateRadio"
							[attr.aria-label]="'initiated date filter selection'">
							<mat-radio-button [value]="'Any'"> Any Initiated Date </mat-radio-button>																					
							<div style="display: flex; flex-direction: row;">
								<mat-radio-button class="radio-option" [value]="'Initiated'" style="margin-right: 1rem;"> Initiated </mat-radio-button>
								<ng-container [ngTemplateOutlet]="initiatedDateFilters"></ng-container>
							</div>	
						</mat-radio-group>
					</div>

					<ng-template #initiatedDateFilters>
						<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
							<mat-form-field class="dropdown" [formGroup]="optionsFg">
								<mat-select formControlName="initiatedDateDropdown">
									<mat-option *ngFor="let dateRangeValue of dateDropdownOptions" [value]="dateRangeValue">{{
										dateRangeValue }}</mat-option>
								</mat-select>
							</mat-form-field>
							<div style="margin-left: 5px">
								<div [hidden]="this.hideField.initiatedDateBetweenMin">
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerIdLower" formControlName="initiatedDateBetweenMin" />
										<mat-datepicker-toggle matSuffix [for]="datePickerIdLower"></mat-datepicker-toggle>
										<mat-datepicker #datePickerIdLower></mat-datepicker>
									</mat-form-field>
								</div>
								<div [hidden]="this.hideField.initiatedDateBetweenMax">
									<div class="and" [hidden]="this.hideField.initiatedDateBetweenMin">and</div>
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerIdUpper" formControlName="initiatedDateBetweenMax" />
										<mat-datepicker-toggle matSuffix [for]="datePickerIdUpper"></mat-datepicker-toggle>
										<mat-datepicker #datePickerIdUpper></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
							<div [hidden]="this.hideField.initiatedDateOn">
								<mat-form-field class="date-field">
									<input matInput [matDatepicker]="datePickerIdOn" formControlName="initiatedDateOn" />
									<mat-datepicker-toggle matSuffix [for]="datePickerIdOn"></mat-datepicker-toggle>
									<mat-datepicker #datePickerIdOn></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
					
					</ng-template>
				</div>
			</fieldset>
		</div>		
		<div style="display: flex; flex-direction: row; gap: 3rem;">
			<!-- Out Date -->
			<fieldset style="padding-right: 3.6rem; margin-right: -0.3rem;">
				<div style="display: flex; flex-direction: row">
					<div style="display: flex; flex-direction: row; margin-right: 0.5rem">
						<div [formGroup]="radiosFg">
							<mat-radio-group
								color="primary"
								style="display: flex; flex-direction: column;"
								class="flex-radio-group"
								formControlName="outDateRadio"
								[attr.aria-label]="'out date filter selection'">
								<mat-radio-button [value]="'Any'"> Any Out Date </mat-radio-button>															
								<div style="display: flex; flex-direction: row;">
									<mat-radio-button class="radio-option" [value]="'Out'" style="margin-right: 1rem;"> Out </mat-radio-button>
									<ng-container [ngTemplateOutlet]="outDateFilters"></ng-container>
								</div>								
								<mat-radio-button class="radio-option" [value]="'None'" style="margin-top: -0.5rem;"> No Out Date </mat-radio-button>
							</mat-radio-group>
						</div>
						<ng-template #outDateFilters>
							<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
								<mat-form-field class="dropdown" [formGroup]="optionsFg">
									<mat-select formControlName="outDateDropdown">
										<mat-option *ngFor="let dateRangeValue of outDateRangeValues" [value]="dateRangeValue">{{ dateRangeValue }}</mat-option>
									</mat-select>
								</mat-form-field>
								<div [hidden]="true" [formGroup]="this.filterFg">
									<!-- Need this to avoid missing control value accessor error. Hidden because it's updated programmatically when the 'No Out Date' radio is selected -->
									<mat-radio-group formControlName="fireOutDateNone"> </mat-radio-group>
								</div>
								<div style="margin-left: 5px">
									<div [hidden]="this.hideField.fireOutBetweenMin">
										<mat-form-field class="date-field">
											<input matInput [matDatepicker]="datePickerOutLower" formControlName="fireOutBetweenMin" />
											<mat-datepicker-toggle matSuffix [for]="datePickerOutLower"></mat-datepicker-toggle>
											<mat-datepicker #datePickerOutLower></mat-datepicker>
										</mat-form-field>
									</div>
									<div [hidden]="this.hideField.fireOutBetweenMax">
										<div class="and" [hidden]="this.hideField.fireOutBetweenMin">and</div>
										<mat-form-field class="date-field">
											<input matInput [matDatepicker]="datePickerOutUpper" formControlName="fireOutBetweenMax" />
											<mat-datepicker-toggle matSuffix [for]="datePickerOutUpper"></mat-datepicker-toggle>
											<mat-datepicker #datePickerOutUpper></mat-datepicker>
										</mat-form-field>
									</div>
								</div>
								<div [hidden]="this.hideField.fireOutDateOn">
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerOutOn" formControlName="fireOutDateOn" />
										<mat-datepicker-toggle matSuffix [for]="datePickerOutOn"></mat-datepicker-toggle>
										<mat-datepicker #datePickerOutOn></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
						</ng-template>
					</div>
				</div>
			</fieldset>
			<!-- Last Published Date -->
			<fieldset>
				<div style="display: flex; flex-direction: row">
					<div style="display: flex; flex-direction: row; margin-right: 0.5rem">
						<div [formGroup]="radiosFg">
							<mat-radio-group
								color="primary"
								style="display: flex; flex-direction: column;"
								class="flex-radio-group"
								formControlName="lastPublishedDateRadio"
								[attr.aria-label]="'last published date filter selection'">
								<mat-radio-button [value]="'Any'"> Any Last Published Date </mat-radio-button>														
								<div style="display: flex; flex-direction: row;">
									<mat-radio-button class="radio-option" [value]="'Published'" style="margin-right: 1rem;"> Last Published </mat-radio-button>
									<ng-container [ngTemplateOutlet]="publishedDateFilters"></ng-container>
								</div>										
								<mat-radio-button class="radio-option" [value]="'None'" style="margin-top: -0.5rem;"> No Last Published Date </mat-radio-button>
							</mat-radio-group>
						</div>
						<ng-template #publishedDateFilters>
							<div style="display: flex; flex-direction: row; align-items: center" [formGroup]="filterFg">
								<mat-form-field class="dropdown" [formGroup]="optionsFg">
									<mat-select formControlName="lastPublishedDateDropdown">
										<mat-option *ngFor="let dateRangeValue of dateDropdownOptions" [value]="dateRangeValue">{{ dateRangeValue }}</mat-option>
									</mat-select>
								</mat-form-field>
								<div [hidden]="true" [formGroup]="this.filterFg">
									<!-- Need this to avoid missing control value accessor error. Hidden because it's updated programmatically when the 'No Last Published Date' radio is selected -->
									<mat-radio-group formControlName="lastPublishedDateNone"> </mat-radio-group>
								</div>
								<div style="margin-left: 5px">
									<div [hidden]="this.hideField.lastPublishedDateBetweenMin">
										<mat-form-field class="date-field">
											<input matInput [matDatepicker]="datePickerLpdLower" formControlName="lastPublishedDateBetweenMin" />
											<mat-datepicker-toggle matSuffix [for]="datePickerLpdLower"></mat-datepicker-toggle>
											<mat-datepicker #datePickerLpdLower></mat-datepicker>
										</mat-form-field>
									</div>
									<div [hidden]="this.hideField.lastPublishedDateBetweenMax">
										<div class="and" [hidden]="this.hideField.lastPublishedDateBetweenMin">and</div>
										<mat-form-field class="date-field">
											<input matInput [matDatepicker]="datePickerLpdUpper" formControlName="lastPublishedDateBetweenMax" />
											<mat-datepicker-toggle matSuffix [for]="datePickerLpdUpper"></mat-datepicker-toggle>
											<mat-datepicker #datePickerLpdUpper></mat-datepicker>
										</mat-form-field>
									</div>
								</div>
								<div [hidden]="this.hideField.lastPublishedDateOn">
									<mat-form-field class="date-field">
										<input matInput [matDatepicker]="datePickerLpdOn" formControlName="lastPublishedDateOn" />
										<mat-datepicker-toggle matSuffix [for]="datePickerLpdOn"></mat-datepicker-toggle>
										<mat-datepicker #datePickerLpdOn></mat-datepicker>
									</mat-form-field>
								</div>
							</div>
						</ng-template>
					</div>
				</div>
			</fieldset>
		</div>
	</div>
	<br>
	<div>
		<div class="geographic-area" [formGroup]="filterFg">
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Geographic Area</mat-label>
					<mat-select formControlName="geographicAreaIds" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let geographicArea of geographicAreasList$ | async" [value]="geographicArea.geographicAreaId">{{
							geographicArea.shortName
						}}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 16px">
					<mat-label>State</mat-label>
					<mat-select formControlName="pooStates" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let state of statesList$ | async" [value]="state">{{ state }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Jurisdictional Agency</mat-label>
					<mat-select formControlName="jurisdicitonalAgencyAtPooId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let agency of agenciesList$ | async" [value]="agency.jurisdictionalAgencyId">{{ agency.shortName }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="width: 400px; margin-right: 16px">
					<mat-label>Jurisdictional Unit</mat-label>

					<mat-select formControlName="jurisdicitonalUnitId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let unit of unitsList$ | async" [value]="unit.unitId" [disabled]="noJurisdictionSelection"
							>{{ unit.unitIrwinId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div>
				<mat-form-field style="width: 400px">
					<mat-label>Protecting Unit</mat-label>
					<mat-select formControlName="protectingUnitId" canSelectNullableOptions>
						<mat-option [value]="null">No Selection</mat-option>
						<mat-option *ngFor="let unit of unitsList$ | async" [value]="unit.unitId" [disabled]="noProtectingUnitSelection"
							>{{ unit.unitIrwinId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<button class="primary-button" (click)="onSearch()">Search</button>
</div>
<div style="display: flex; justify-content: space-between">
	<div></div>
	<wfdss-export-button style="display: flex" (click)="download()"></wfdss-export-button>
</div>
<div id="current-li-table" style="margin: 0px 30px">
	<table
		mat-table
		class="app-table"
		[dataSource]="tableDataSource"
		style="width: 100%"
		[fixedLayout]="fixedLayout"
		matSort
		[matSortActive]="sortActive"
		[matSortDirection]="sortDirection"
		[matSortDisableClear]="true"
		aria-describedby="Wfdss Case Records Table">
		<ng-container matColumnDef="Incident Name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Incident Name</th>
			<td *matCellDef="let row" mat-cell style="cursor: pointer">
				<a (click)="onClickIncident(row)">{{ row.name }}</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="Unique Fire Identifier">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Unique Fire Identifier</th>
			<td *matCellDef="let row" mat-cell>{{ row.uniqueFireIdentifier }}</td>
		</ng-container>
		<ng-container matColumnDef="Geographic Area">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Geographic Area</th>
			<td *matCellDef="let row" mat-cell>{{ row?.geographicArea?.shortName }}</td>
		</ng-container>
		<ng-container matColumnDef="Jurisdiction(s)">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Jurisdiction</th>
			<td *matCellDef="let row" mat-cell>{{ row.jurisdictionalAgencyAtPoO?.shortName }}</td>
		</ng-container>
		<ng-container matColumnDef="Protecting Unit">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Protecting Unit</th>
			<td *matCellDef="let row" mat-cell> {{row | protectingUnit}}</td>
		</ng-container>
		<ng-container matColumnDef="State">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
			<td *matCellDef="let row" mat-cell>{{ row.pooState }}</td>
		</ng-container>
		<ng-container matColumnDef="Size (Acres)">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Size (Acres)</th>
			<td *matCellDef="let row" mat-cell>{{ row.incidentSize }}</td>
		</ng-container>
		<ng-container matColumnDef="Discovery Date/Time">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="date-column">Discovery Date/Time</th>
			<td *matCellDef="let row" mat-cell>{{ row.fireDiscoveryDateTime | unixToMomentDate : "MM/DD/YY HH:mm" }}</td>
		</ng-container>
		<ng-container matColumnDef="Decision Initiated Date">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="date-column">Decision Initiated Date</th>
			<td *matCellDef="let row" mat-cell>{{row.initiatedDate ? (row.initiatedDate | unixToMomentDate : "MM/DD/YY HH:mm") : '' }}</td>
		</ng-container>
		<ng-container matColumnDef="Last Published Date">
			<th mat-header-cell *matHeaderCellDef mat-sort-header class="date-column">Last Published Date</th>
			<td *matCellDef="let row" mat-cell>{{ row.lastPublishedDate ? (row.lastPublishedDate | unixToMomentDate : "MM/DD/YY HH:mm") : '' }}</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="columns"></tr>
		<tr tabindex="0" mat-row *matRowDef="let row; columns: columns"></tr>
	</table>
	<mat-paginator [pageSizeOptions]="[10, 20]" [pageSize]="defaultPageSize" #paginator></mat-paginator>
</div>
